import React, { useState, useEffect } from "react";
import { Heading1 } from "../Headings/Headings";

const HomeScreenGreeting = ({ username, reRenderGreeting }) => {
  const [greeting, setGreeting] = useState("");

  const greetings = {
    earlyMorning: [
      `${username}: Early care?`,
      `${username}'s dawn dedication.`,
      `Healing starts early, ${username}.`,
      `Night's end, ${username}?`,
      `${username}: Still going?`,
      `Early riser, ${username}?`,
      `${username}'s sunrise shift.`,
      `Morning's prelude, ${username}.`,
      `${username}: Fresh start?`,
      `Brewing, ${username}?`,
      `First light, ${username}.`,
      `${username}: Morning brew?`,
      `Dawn breaks, ${username}.`,
      `Start's spark, ${username}.`,
      `${username}: New horizon?`,
    ],
    morning: [
      `Morning care, ${username}?`,
      `${username}'s sunrise service.`,
      `New day, ${username}.`,
      `Morning rounds, ${username}?`,
      `${username}: Day's start.`,
      `Healing morning, ${username}.`,
      `Bright start, ${username}?`,
      `${username}'s AM duties.`,
      `${username}: Rise again.`,
      `Day's promise, ${username}.`,
      `Breakfast rounds, ${username}?`,
      `${username}'s new chapter.`,
      `Sunny side, ${username}?`,
      `Blossoming day, ${username}.`,
      `${username}: Morning mood?`,
    ],
    afternoon: [
      `Afternoon healing, ${username}?`,
      `${username}'s day peak.`,
      `Busy hours, ${username}?`,
      `Caring continues, ${username}.`,
      `${username}: Midday check.`,
      `Afternoon watch, ${username}.`,
      `${username}'s sunlight shift.`,
      `Progressing, ${username}?`,
      `${username}: Noon realm?`,
      `Midday's peak, ${username}.`,
      `${username}: Steady pace?`,
      `Lunch break, ${username}?`,
      `Golden hour, ${username}.`,
      `${username}'s afternoon glow.`,
      `Halfway there, ${username}.`,
    ],
    evening: [
      `Evening rounds, ${username}?`,
      `${username}'s sunset service.`,
      `Day's close, ${username}.`,
      `Winding down, ${username}?`,
      `${username}: Twilight time.`,
      `Evening care, ${username}.`,
      `${username}'s PM duties.`,
      `Night's intro, ${username}.`,
      `Sunset serenade, ${username}.`,
      `${username}: Dimming down?`,
      `Golden glow, ${username}.`,
      `Star's prelude, ${username}.`,
      `${username}: Night's nudge?`,
      `Evening ease, ${username}.`,
      `Twinkling twilight, ${username}.`,
    ],
    night: [
      `${username}: Night care?`,
      `Stars out, ${username} in.`,
      `Rest or rounds, ${username}?`,
      `Night dedication, ${username}.`,
      `${username}'s moonlight shift.`,
      `Late watch, ${username}?`,
      `${username}: Night's duties.`,
      `Dreaming or doing, ${username}?`,
      `${username}: Starry sights?`,
      `Peaceful pause, ${username}.`,
      `${username}: Nightfall nod?`,
      `Silent serenity, ${username}.`,
      `${username}: Moonlit muse?`,
      `Dreams beckon, ${username}.`,
      `Night whispers, ${username}.`,
    ],
  };

  useEffect(() => {
    function getGreeting() {
      const hour = new Date().getHours();
      let currentGreetings;

      if (hour >= 0 && hour <= 6) currentGreetings = greetings.earlyMorning;
      else if (hour <= 12) currentGreetings = greetings.morning;
      else if (hour <= 17) currentGreetings = greetings.afternoon;
      else if (hour <= 20) currentGreetings = greetings.evening;
      else currentGreetings = greetings.night;

      // Filter out the current greeting
      const possibleGreetings = currentGreetings.filter((g) => g !== greeting);

      // Randomly select a greeting from the remaining possible greetings
      return possibleGreetings[
        Math.floor(Math.random() * possibleGreetings.length)
      ];
    }

    // Update the greeting
    setGreeting(getGreeting());
  }, [reRenderGreeting]);

  return <Heading1 headingText={greeting} />;
};

export default HomeScreenGreeting;
